﻿module.exports = {
    "id": "ar",
    "label": "العربية",
    "rtl": true,

    "translations": {
        "INVALID_LINK_TITLE":           "الرابط خطأ",
        "INVALID_LINK_TEXT":            "الرجاء استخدام الرابط في الموجود في بريدك الالكتروني لالغاء التسجيل بقوائمنا.",
        "UNSUBSCRIBE_ARE_YOU_SURE":     "هل انت متأكد انك تريد الغاء التسجيل من قوائمنا",
        "UNSUBSCRIBE_CLICK_CONFIRM":    "زر اضغط على \"الغاء التسجيل\"ادناه لتأكيد الالغاء",
        "YOU_HAVE_BEEN_UNSUBSCRIBED":   "لقد تم <b>الغاء تسجيلك</b> من قوائمنا.",
        "UNSUBSCRIBED_IN_ERROR":        "اذا كان لديك خطا بالغاء التسجيل, يرجى الضغط على الرابط <a href='/resubscribe' class='resubscribe'>الغاء التسجيل</a>.",
        "CANCELLED_STILL_SUBSCRIBED":   "<b>الغاء.</b> انت لا تزال <b>مسجل</b> بقوائمنا.",
        "THANK_YOU_FOR_CONTINUING":     "شكرا لاستمرار المشاركه بدراساتنا.",
        "EMAIL_ALREADY_UNSUBSCRIBED":   "هذا الايميل <b> تم الغاء تسجيله</b>مسبقا من قوائمنا.",
        "CLICK_RESUBSCRIBE_TO_REJOIN":  "اضغط زر \"اعد التسجيل\" بالاسفل ليتم اعادتك للقائمه.",
        "YOU_HAVE_BEEN_RESUBSCRIBED":   "لقد تم <b>اعاده تسجيلكم</b> بقوائمنا.",
        "YOU_ARE_ALREADY_SUBSCRIBED":   "انتم <b>مسجلين</b> سابقا بقوائمنا.",
        "THANK_YOU_FOR_PARTICIPATING":  "شكرا لمشاركتكم بدراساتنا.",
        "CHECKING":                     "يتم التأكيد...",
        "UNSUBSCRIBE":                  "الغاء التسجيل",
        "RESUBSCRIBE":                  "اعد التسجيل",
        "EMAIL":                        "بريد الكتروني",
        "CANCEL":                       "الغاء"
    }
};

